import { type FC, type ReactNode, type SVGProps } from 'react';

import clsx from 'clsx';

import { Icon } from '@/shared/ui/icon';

// eslint-disable-next-line import/no-duplicates
import { ReactComponent as BoostIcon } from '@/assets/images/boosters/boost-flat.svg?react';
// eslint-disable-next-line import/no-duplicates
import { ReactComponent as PlaycoinIcon } from '@/assets/images/landing/playcoin.svg?react';

// eslint-disable-next-line import/no-duplicates
import boostIconUrl from '@/assets/images/boosters/boost-flat.svg';
// eslint-disable-next-line import/no-duplicates
import playcoinIconUrl from '@/assets/images/landing/playcoin.svg';

import { XPIcon } from '../../xp-icon/XPIcon';
import { BoosterSize, BoosterType } from '../booster.types';

import s from './BoosterIcon.module.scss';

interface Props {
  className?: string;

  type: BoosterType;
  size: BoosterSize;

  renderAs?: 'inline' | 'img';
}

const BOOST_ICON_BY_RENDER_AS = {
  inline: BoostIcon,
  img: boostIconUrl,
} as const;

const PLAYCOIN_ICON_BY_RENDER_AS = {
  inline: PlaycoinIcon,
  img: playcoinIconUrl,
} as const;

const BOOSTER_ICON_BY_TYPE: Record<
  BoosterType,
  (props: SVGProps<SVGSVGElement> & { renderAs: 'inline' | 'img' }) => ReactNode
> = {
  [BoosterType.BOOSTER_XP]: (props) => <XPIcon {...props} />,
  [BoosterType.BOOSTER_PLAYCOIN]: ({ renderAs, ...props }) => (
    <Icon icon={PLAYCOIN_ICON_BY_RENDER_AS[renderAs]} {...props} />
  ),
};

export const BoosterIcon: FC<Props> = ({
  className,
  type,
  size = BoosterSize.MEDIUM,

  renderAs = 'inline',
}) => {
  const BoosterIcon = BOOSTER_ICON_BY_TYPE[type];

  return (
    <div className={clsx(s.container, s[size], className)}>
      <div className={s.round}>
        <Icon icon={BOOST_ICON_BY_RENDER_AS[renderAs]} className={s.boost} />
      </div>
      <BoosterIcon className={s.icon} renderAs={renderAs} />
    </div>
  );
};

BoosterIcon.displayName = 'BoosterIcon';
